import React, { FC, PropsWithChildren } from 'react'
import { Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  container: {
    padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
    backgroundColor: theme.palette.grey.grey07,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.grey.grey06}`,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
  },
}))

/**
 * Common container component for the retrofit page
 */
const Container: FC<PropsWithChildren> = ({ children }) => {
  const { classes } = useStyles()

  return <Box className={classes.container}>{children}</Box>
}

export default Container
